/**
 * Detecta el entorno de despliegue (QA/PROD) según la URL de API.
 */
export const getDeployEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname === "onefinqa.innercor.com.ar") {
    return "QA";
  } else if (hostname === "localhost") {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    if (apiUrl.includes("onefinapiqa")) {
      return "Local - QA";
    } else if (apiUrl.includes("onefinapi")) {
      return "Local - PROD";
    }
    return "Local";
  } else if (hostname === "onefindev.innercor.com.ar") {
    return "Dev";
  }
};
